package fyi.moko.hotpl.domain.model

/** How many food photos a projection carries on top of the cover (backlog 0-36 slice B). */
const val SHARED_FOOD_PHOTO_LIMIT = 3

/**
 * The photo file names a FRIENDS/PUBLIC projection of this place carries — what a friend
 * gets to see (backlog 0-36): the cover first, then up to [SHARED_FOOD_PHOTO_LIMIT]
 * [PhotoKind.FOOD_DRINK] photos from [visits], most recent visit first. A people photo is
 * never shared, even when the user made it the cover; a deleted visit contributes nothing.
 *
 * ── 왜 여기서 한 번만 계산하나 ──────────────────────────
 * 공유 복사본(Storage `shared/{uid}/`)을 올리고 지우는 트리거 — 가시성 전환, 대표 교체,
 * 방문 사진 추가·삭제, 장소 삭제 — 가 전부 "지금 투영이 원하는 집합"과 "이전 투영이 갖고
 * 있던 집합"의 차이로 환원된다. 그 집합의 정의가 여기 하나뿐이어야 push 경로와 투영 DTO가
 * 어긋나지 않는다. 음식 사진은 [Visit.photos]에 있으므로 호출자가 방문 목록을 넘긴다.
 */
fun Place.sharedPhotoFileNames(visits: List<Visit> = emptyList()): List<String> {
    val cover = sharedCoverFileName()
    val food = visits.asSequence()
        .filter { !it.isDeleted }
        .sortedByDescending { it.visitedAt }
        .flatMap { it.photos.asSequence() }
        .filter { it.kind == PhotoKind.FOOD_DRINK }
        .map { it.fileName }
        .filter { it != cover }
        .distinct()
        .take(SHARED_FOOD_PHOTO_LIMIT)
        .toList()
    return listOfNotNull(cover) + food
}

private fun Place.sharedCoverFileName(): String? {
    val cover = imageFileName?.takeIf { name -> photos.any { it.fileName == name } }
        ?: photos.coverFileName()
        ?: imageFileName?.takeIf { photos.isEmpty() }
        ?: return null
    val ref = photos.firstOrNull { it.fileName == cover }
    if (ref != null && (ref.kind == PhotoKind.PEOPLE || ref.resolvedGroup == PhotoGroup.VISIT)) return null
    return cover
}
